// Minimal locking-user reference — tooltip/toast name only.
interface LockedByRef {
  id: number
  firstName: string
  lastName: string
}

export interface SessionLockStatusConstructor {
  isLocked: boolean
  lockedBy: Nullable<LockedByRef>
}

export class SessionLockStatus {
  readonly isLocked: boolean
  readonly lockedBy: Nullable<LockedByRef>

  constructor(data: SessionLockStatusConstructor) {
    this.isLocked = data.isLocked
    this.lockedBy = data.lockedBy
  }

  // "{name} is in the process of reconciling" tooltip / Session Locked toast
  get lockedByFullName(): Nullable<string> {
    return this.lockedBy
      ? `${this.lockedBy.firstName} ${this.lockedBy.lastName}`
      : null
  }

  isLockedByOther(currentUserId: number): boolean {
    return (
      this.isLocked &&
      this.lockedBy !== null &&
      this.lockedBy.id !== currentUserId
    )
  }
}
